import { Route } from '@angular/router';
import { UserService } from '../api/services/user.service';
import { UserListComponent } from './components/user-list/user-list.component';

export default [
  {
    path: '',
    title: 'Te Llevo-Dashboard',
    component: UserListComponent,
    providers: [UserService],
  },
] as Route[];